<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :append-to-body="true"
        :destroy-on-close="true"
        :width="width"
        :class="['vip-unauth-alert', extraClass]"
        :custom-class="['vip-unauth-alert', extraClass].join(' ')"
    >   
        <div class="text-content" v-html="content"></div>
        <template #footer>
            <el-button
                v-if="showCancel"
                size="medium"
                :type="cancelType"
                @click="cancel"
            >{{cancelText}}</el-button>
            <el-button
                v-if="showConfirm"
                size="medium"
                :type="confirmType"
                @click="confirm"
            >{{confirmText}}</el-button>

            <el-button
                v-if="showOther"
                size="medium"
                :type="otherType"
                @click="otherClick"
            >{{otherText}}</el-button>
        </template>
    </el-dialog>
</template>

<script>

let cancel = () => {};
let confirm = () => {};
let other = () => {};

  export default {
    data() {
      return {
        width: '500px',
        dialogVisible: false,
        content: '提示内容',
        extraClass: '', // 追加的自定义样式类，用于个别弹窗单独换肤

        showCancel: false,
        cancelText: '取消',
        cancelType: 'default',

        showConfirm: true,
        confirmText: '确定',
        confirmType: 'primary',

        showOther: false,
        otherText: '',
        otherType: 'default',
      };
    },
    methods: {
        open(option) {
            this.extraClass = option.extraClass || '';
            option.content && (this.content = option.content)
            option.width && (this.width = option.width)
            option.showCancel ? (this.showCancel = option.showCancel) : this.showCancel = false;
			option.cancelText && (this.cancelText = option.cancelText)
            if (option.showConfirm !== undefined && !option.showConfirm) {
                this.showConfirm = false;
            } else {
                this.showConfirm = true;
            }
			option.confirmText && (this.confirmText = option.confirmText)
			option.cancel && (cancel = option.cancel)
			option.confirm && (confirm = option.confirm)

			option.cancelType && (this.cancelType = option.cancelType)
			option.confirmType && (this.confirmType = option.confirmType)

            this.showOther = option.showOther || false;
            this.otherText = option.otherText || '';
            this.otherType = option.otherType || 'default';
            option.other && (other = option.other)

            this.dialogVisible = true;
        },
        close() {
			this.dialogVisible = false;
		},
		cancel() {
			cancel();
			this.close();
		},
		confirm() {
			confirm();
			this.close();
		},
        otherClick() {
            other();
			this.close();
        }
    }
  };
</script>

<style lang="less">
    .vip-unauth-alert{
        .text-content{
            font-size: 16px;
            line-height: 30px;
        }
        &.el-dialog{
            background: #ecf5ff;
            border: 1px solid #b3d8ff;
            border-radius: 10px !important;
        }
        .el-dialog__header{
            padding: 0;
        }
        .el-dialog__body{
            padding-top: 24px;
            padding-bottom: 0;
        }
        .el-dialog__footer{
            text-align: center;
            width: 100%;
            display: block;
        }
        .el-dialog__headerbtn{
            top: 10px;
            right: 10px;
            font-size: 20px;
        }
    }
    // 白色皮肤：整体背景改白，配合 open({ extraClass: 'vip-unauth-alert--white' }) 使用
    .vip-unauth-alert--white{
        &.el-dialog{
            background: #fff;
            border: 1px solid #ebeef5;
        }
    }
</style>
